import { FormHelperText } from "@material-ui/core";
import { FieldProps, getIn } from "formik";
import TextInput from "components/front/layout/TextInput";
import { OrderCreateInput } from "lib/service/client/FrontOrderService";
import { PickupContact } from "interfaces/front/page/orderForm";
import React, { FC, useMemo } from "react";
import styled from "styled-components";

type Props = FieldProps<OrderCreateInput>;

const DEFAULT_CONTACT: PickupContact = { name: "", phone_number: "" };

const PickupContactField: FC<Props> = ({ field, form }) => {
  const contact = useMemo(() => {
    const current = getIn(form.values, field.name) as PickupContact | undefined;
    return current ?? DEFAULT_CONTACT;
  }, [form.values, field.name]);

  const handleChange = (key: keyof PickupContact) => (event: React.ChangeEvent<HTMLInputElement>) => {
    form.setFieldValue(field.name, { ...contact, [key]: event.target.value });
  };

  const handleBlur = (key: keyof PickupContact) => () => {
    form.setFieldTouched(`${field.name}.${key}`, true, false);
  };

  const nameError = getIn(form.errors, `${field.name}.name`);
  const nameTouched = getIn(form.touched, `${field.name}.name`);
  const phoneError = getIn(form.errors, `${field.name}.phone_number`);
  const phoneTouched = getIn(form.touched, `${field.name}.phone_number`);

  return (
    <>
      <FieldBlock>
        <Label htmlFor={`${field.name}-name`}>お名前(カタカナ)</Label>
        <StyledTextInput
          id={`${field.name}-name`}
          value={contact.name}
          onChange={handleChange("name")}
          onBlur={handleBlur("name")}
          placeholder="アキバタロウ"
          $error={Boolean(nameError && nameTouched)}
        />
        {nameError && nameTouched && <StyledFormHelperText error>{nameError as string}</StyledFormHelperText>}
      </FieldBlock>
      <FieldBlock>
        <Label htmlFor={`${field.name}-phone`}>電話番号</Label>
        <StyledTextInput
          id={`${field.name}-phone`}
          value={contact.phone_number}
          onChange={handleChange("phone_number")}
          onBlur={handleBlur("phone_number")}
          placeholder="09012345678"
          $error={Boolean(phoneError && phoneTouched)}
        />
        {phoneError && phoneTouched && <StyledFormHelperText error>{phoneError as string}</StyledFormHelperText>}
      </FieldBlock>
    </>
  );
};

export default PickupContactField;

const FieldBlock = styled.div`
  margin: 20px auto 0;
  max-width: 360px;
  width: 100%;
  padding: 0 12px;

  @media (max-width: 480px) {
    max-width: 92vw;
    padding: 0 8px;
  }
`;
const Label = styled.label`
  display: block;
  margin-bottom: 6px;
  font-size: 14px;
`;
const StyledTextInput = styled(TextInput)`
  width: 100%;
`;
const StyledFormHelperText = styled(FormHelperText)`
  margin-top: 4px !important;
`;
